// extracted by mini-css-extract-plugin
module.exports = {"locationsBreadcrumbs":"az_q3","breadcrumbNav":"az_r3","breadcrumbItem":"az_s3","breadcrumbSeparator":"az_t3","noHorizontalMargin":"az_u3","noVerticalMargin":"az_v3"};